import styles from "./magazine.module.css";
const Magazine = ({ src }) => {
  return (
    <>
      <div className={styles.canvas}>
        <iframe
          allow="clipboard-write"
          sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
          allowFullScreen="true"
          src={src}
        ></iframe>
      </div>
    </>
  );
};
export default Magazine;
